import { useFetch } from "~vue/api";
import type { PerformanceReviewConversationListItem } from "~vue/types/performance_management";

export const usePerformanceReviewConversations = (performanceMomentId: number) => {
    const fetchUrl = `/api/coach/performance_reviews/conversations/?performance_moment_id=${performanceMomentId}`;
    return useFetch(fetchUrl, { refetch: true }).get().json<{ conversations: Array<PerformanceReviewConversationListItem> }>();
};
